module.exports = __webpack_public_path__ + "static/media/ico-success-step.0ebf1eb5.svg";